



















































































































import {
  defineComponent,
  onMounted,
  computed,
  onUnmounted,
  ref,
} from '@vue/composition-api';
import { biClick } from '@tencent/fit-bi-sdk';
import { i18n } from '@/i18n';
import { FitButton } from '@tencent/wphk-ui';
import { ArrowLeftIcon } from '@tencent/wphk-icon-vue';
import { useRoute } from '@/hooks/use-route';
import { windowHelper } from '@tencent/ppd-base-libs';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import {
  jumpScanpayByCouponId,
  QrpayFromScene,
  JumpScanpayExeption,
} from '@tencent/wphk-components-jump-page';
import { useCouponDetail } from '@/views/coupon-detail/use-coupon-detail';
import { CouponDetailType } from '@tencent/wphk-act-base-cgi';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './content-loader.vue';
import { parseHK$Aria, CouponAmount } from '@tencent/wphk-act-base-ui';
import { showBusinessError, hideDialog } from '@tencent/wphk-components-dialog';
import { to } from '@tencent/wphk-base-utils';

export default defineComponent({
  name: 'CouponDetail',
  components: {
    FitButton,
    LanuchWeapp,
    BaseComponent,
    ContentLoader,
    CouponAmount,
    ArrowLeftIcon,
  },
  setup() {
    const { route, router } = useRoute();
    // 跳转到原生付款码页面
    const jumpScanpayPage = ref(false);
    const jumpScanpayLoading = ref(false);
    const {
      requiredContent,
      btnInfo,
      isCouponDetailReady,
      biExt,
      validityContent,
      couponDetail,
      amountContent,
      lang,
    } = useCouponDetail(route.query.user_coupon_id as string);

    function onPageVisiblilityChange() {
      if (!document.hidden && jumpScanpayPage.value) {
        location.reload();
      }
    }

    /**
     * 使用优惠券拉起刷卡支付
     * @param userCouponId 优惠券ID
     */
    async function jumpScanpay(userCouponId = '') {
      const [err] = await to(jumpScanpayByCouponId(userCouponId, 'couponDetail', {
        scene: QrpayFromScene.HKLife,
      }));
      if (err) {
        showBusinessError(err, {
          btns: [
            {
              text: i18n('我知道了'),
              click: () => {
                hideDialog();
                // 券已使用时，需刷新页面更新券状态
                if (err.name === JumpScanpayExeption.CouponUsed) {
                  location.reload();
                }
              },
            },
          ],
        });
      } else {
        jumpScanpayPage.value = true;
      }
    }

    onMounted(() => {
      document.title = i18n('优惠券');
      document.addEventListener('visibilitychange', onPageVisiblilityChange);
    });

    onUnmounted(() => {
      document.removeEventListener('visibilitychange', onPageVisiblilityChange);
    });

    // 是否有品牌信息
    const hasBrandInfo = computed(() => couponDetail.value?.brandName && couponDetail.value.brandLogo);
    const logo = computed(() => (hasBrandInfo.value
      ? couponDetail.value?.brandLogo
      : couponDetail.value?.couponLogo));
    // 是否展示按钮
    const showBtn = computed(() => btnInfo.value?.btnText && couponDetail.value?.useChannel !== 3);
    // 是否跳小程序
    const jumpMiniProgram = computed(() => couponDetail.value?.path
        && couponDetail.value.username
        && btnInfo.value?.btnStatus !== 'inactive');
    // 是否是折扣券
    const isDiscountCoupon = computed(() => couponDetail.value?.couponType === CouponDetailType.DISCOUNT_COUPON);

    return {
      couponDetail,
      requiredContent,
      validityContent,
      amountContent,
      hasBrandInfo,
      jumpMiniProgram,
      isDiscountCoupon,
      showBtn,
      logo,
      lang,
      btnInfo,
      isCouponDetailReady,
      parseHK$Aria,
      jumpSp() {
        if (!couponDetail.value?.spidJumpUrl) {
          return;
        }
        windowHelper.redirect(couponDetail.value?.spidJumpUrl, 300);
        biClick('coupon-detail.spurl_click|spurl跳转点击', biExt.value);
      },
      jumpTnc() {
        windowHelper.redirect(couponDetail.value?.tncUrl, 300);
        biClick('coupon-detail.tnc_click|tnc跳转点击', biExt.value);
      },
      jumpCustom() {
        windowHelper.redirect(couponDetail.value?.customizeJumpUrl, 300);
        biClick('coupon-detail.customjump_click|自定义跳转点击', biExt.value);
      },
      goBackToList() {
        biClick(
          'coupon-detail.return-to-my-rewards_click|返回我的优惠券点击',
          biExt.value,
        );
        if (route.query.from === 'couponList') {
          router.go(-1);
        } else {
          router.push({ name: 'couponlist' });
        }
      },
      async clickBtn() {
        if (jumpScanpayLoading.value) return;

        const { path, username, buttonUrl, userCouponId, useChannel } = couponDetail.value || {};
        if (path || username) return;
        if (btnInfo.value?.btnStatus === 'inactive' || !btnInfo.value?.btnText) return;
        if (useChannel === 1) {
          jumpScanpayLoading.value = true;
          const [err] = await to(jumpScanpay(userCouponId));
          jumpScanpayLoading.value = false;
          if (err) {
            throw err;
          }
        } else {
          windowHelper.redirect(buttonUrl, 300);
        }
        biClick('coupon-detail.btn_click|按钮点击', biExt.value);
      },
    };
  },
});
